// extracted by mini-css-extract-plugin
export default {"group":"ygdT","right-label":"OhiP","rightLabel":"OhiP"};